import PageError from 'pages/404';

const Error = ({ statusCode }) => {
  //   console.log(statusCode);
  return <PageError statusCode={statusCode} />;
};

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
